<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <page-title>Dashboard</page-title>
    <div class="columns flex-row wrap justify-space-evenly">
      <div class="column">
        <DashboardCard
          title="Incoming Shipments"
          :data="portDashboardStats.incoming"
          link="incoming-shipments"
        ></DashboardCard>
      </div>
      <div class="column">
        <DashboardCard
          title="Berth Shipments"
          :data="portDashboardStats.docked"
          link="berth-shipments"
        ></DashboardCard>
      </div>

      <div class="column">
        <DashboardCard
          title="Expected Departures"
          :data="portDashboardStats.departure || 0"
          link="expected-departures"
        ></DashboardCard>
      </div>
      <div class="column">
        <DashboardCard
          title="Port History"
          :data="portDashboardStats.total_shipping_requests || 0"
          link="port-history"
        ></DashboardCard>
      </div>
    </div>

    <div class="columns flex-row wrap justify-space-around">
      <div class="column">
        <DashboardCard title="Update Status" hasBg link="incoming-shipments"></DashboardCard>
      </div>
      <div class="column">
        <DashboardCard title="Port Guide" hasBg link="port-guide"></DashboardCard>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardCard from "../components/DashboardCard.vue";
import GetPortsDashboardData from "@/modules/portsModule/api/graphql/queries/GetPortsDashboardData.gql";
import { mapMutations, mapGetters } from "vuex";
import { PORT_MUTATION_TYPES } from "@/store/mutation-types";
import {
  mapGetters as mapRootGetters,
  mapMutations as mapRootMutations
} from "vuex";
import { ROOT_MUTATION_TYPES } from "@/store/mutation-types.js";
import GetPortsQuery from "@/modules/commonModule/api/graphql/queries/GetPorts";

export default {
  name: "dashboard",
  components: { DashboardCard },

  data() {
    return {
      isLoading: false,
      portID: ""
    };
  },

  created: function() {
    if (!this.portsFromVuex.loaded) {
      this.loadPortsFromAPI();
    }
  },

  mounted() {
    this.portID = this.getPortID();
    // this.loadAllShippingRequests();
    // this.loadShippersSavedShippingRequests();

    this.loadPortsDashboardData();
  },

  computed: {
    ...mapRootGetters({
      portsFromVuex: "getPorts",
    }),
    ...mapGetters({
      portShippingRequestStatistics: "getPortShippingRequestStatistics"
    }),
    portDashboardStats() {
      if (!this.portShippingRequestStatistics) {
        return {
          incoming: 0,
          departure: 0,
          total_shipping_requests: 0,
          docked: 0
        };
      } else {
        return this.portShippingRequestStatistics;
      }
    }
  },

  methods: {
    ...mapRootMutations({
      updatePorts: ROOT_MUTATION_TYPES.SAVE_PORTS
    }),
    ...mapMutations({
      savePortsShippingRequestStatistics:
        PORT_MUTATION_TYPES.SAVE_PORT_SHIPPING_REQUEST_STATISTICS
    }),

    getPortID() {
      return this.$store.getters.getPortID;
    },

    loadPortsFromAPI: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsQuery
        })
        .then(response => {
          const ports = response.data.ports;
          this.updatePorts(ports);
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message: "Failed to load list of ports",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    /**
     * Load all the data needed on the shippers dashboard
     */
    loadPortsDashboardData() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetPortsDashboardData,
          variables: {
            port_id: this.portID.toString()
          }
        })
        .then(response => {
          const statistics = response.data.getPortsShippingRequestStatistics;

          this.savePortsShippingRequestStatistics(statistics);

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Port's Shipping application data has been loaded.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "An error occured while trying to retrieve data",
            type: "is-danger"
          });
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.card {
  margin: 1em;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #6e98ff;
  box-shadow: 0px 0px 20px 1px #ccc;
}

.level {
  justify-content: space-evenly !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.columns {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bgColor {
  background-color: #000;
  border: none !important;
}
</style>
